import { Effect, RequestResolver } from 'effect';
import { Url } from '../../..';
import { decodeOptions, decodeSpaces } from '../schema';
import { GetOptionsError, GetSpacesError } from './requests';
export const GetSpacesResolver = (http, gavelUrl) => RequestResolver.fromEffect((request) => http
    .get(Url.join(gavelUrl, `/api/v1/${request.tenant}/spaces`), {
    'content-type': 'application/json',
})
    .pipe(Effect.mapError(e => new GetSpacesError({ originalError: e })), Effect.andThen(r => decodeSpaces(r.body))));
export const GetOptionsResolver = (http, gavelUrl) => RequestResolver.fromEffect((request) => http
    .get(Url.join(gavelUrl, `/api/v1/${request.tenant}/options`), { 'content-type': 'application/json' }, {
    space: request.spaceId,
})
    .pipe(Effect.mapError(e => new GetOptionsError({ originalError: e })), Effect.andThen(r => decodeOptions(r.body))));
